<template>
  <div>
    <div class="row">
      <div class="col-md-6 pt-0 pb-0">
        <!-- <label class="m-0">TIPO</label> -->
        <v-select
          small-chips
          dense
          hide-details
          v-model="types"
          :items="[
            { id: 'SERVICO', label: 'SERVIÇO' },
            { id: 'PRODUTO', label: 'PRODUTO' },
            { id: 'MEDICAMENTO', label: 'MEDICAMENTO' },
            { id: 'HOSPEDAGEM', label: 'HOSPEDAGEM' },
          ]"
          chips
          label="TIPO"
          multiple
          solo
          item-text="label"
          item-value="id"
          @change="handleChangeFilterType"
        />
      </div>
      <div
        v-show="types.includes('PRODUTO') || types.includes('MEDICAMENTO')"
        class="col-md-3 pt-0 pb-0"
      >
        <!-- <label class="m-0">ORIGEM</label> -->
        <v-select
          dense
          v-model="origin"
          :items="[
            { id: null, label: 'TODOS' },
            { id: 'FAMILIA', label: 'FAMÍLIA' },
            { id: 'EMPRESA', label: 'EMPRESA' },
          ]"
          label="ORIGEM"
          solo
          item-text="label"
          item-value="id"
          @change="handleChangeFilterOrigin"
        />
      </div>
      <div
        v-show="types.includes('PRODUTO') || types.includes('MEDICAMENTO')"
        class="col-md-3 pt-0 pb-0"
      >
        <!-- <label class="m-0">MOVIMENTAÇÃO</label> -->
        <v-select
          dense
          v-model="movement"
          :items="movements"
          label="MOVIMENTAÇÃO"
          solo
          item-text="label"
          item-value="id"
          @change="handleChangeFilter"
        >
          <template v-slot:item="{ item }">
            {{ item.label }}
          </template>
        </v-select>
      </div>
      <div v-show="movement != 'ENTRADA'" class="col-md-6 pt-0 pb-0">
        <!-- <label class="m-0">STATUS</label> -->
        <v-select
          small-chips
          dense
          hide-details
          v-model="status"
          :items="[
            { id: 'FATURADO', label: 'FATURADO' },
            { id: 'AGUARDANDO_PAGAMENTO', label: 'AGUARDANDO PAGAMENTO' },
            { id: 'ATRASADO', label: 'ATRASADO' },
            { id: 'PAGO', label: 'PAGO' },
          ]"
          chips
          label="STATUS"
          multiple
          solo
          item-text="label"
          item-value="id"
          @change="handleChangeFilter"
        />
      </div>
      <div
        class="col-md-3 pt-0 pb-0"
        v-show="status.includes('AGUARDANDO_PAGAMENTO')"
      >
        <!-- <label class="m-0">DATA</label> -->
        <v-text-field
          @input="handleChangeFilter"
          v-model="due_date"
          type="date"
          dense
          outlined
          label="DATA"
        />
      </div>
      <div class="col-md-12 pt-0 pb-0"><hr /></div>
      <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
        <div class="input-group">
          <div class="input-group-pprend">
            <v-btn
              :disabled="loading"
              @click="handlePrevMonth"
              class="v-dark noBorderRadius shadow-none"
              style="height: 31px"
              ><i class="fas fa-arrow-left"></i
            ></v-btn>
          </div>
          <input
            :disabled="loading"
            v-if="dayMonthYear == 'day'"
            v-model="month"
            type="date"
            class="form-control form-control-sm"
          />
          <input
            :disabled="loading"
            v-if="dayMonthYear == 'month'"
            v-model="month"
            type="month"
            class="form-control form-control-sm"
            @input="paginate"
          />
          <input
            :disabled="loading"
            v-if="dayMonthYear == 'year'"
            v-model="month"
            type="text"
            class="form-control form-control-sm"
            maxlength="4"
            minlength="4"
            @input="handleInputMonthTypeYear($event.target.value)"
          />
          <div class="input-group-pprend">
            <v-btn
              :disabled="loading"
              @click="handleNextMonth"
              class="v-dark noBorderRadius shadow-none"
              style="height: 31px"
            >
              <i class="fas fa-arrow-right"></i>
            </v-btn>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-4 col-md-4 col-sm-6 col-12">
        <v-btn
          :disabled="loading"
          class="submenu-finacial"
          style="height: 31px"
          @click="handleDayMonthYear('day')"
          :class="[dayMonthYear == 'day' && 'v-dark']"
          >Dia</v-btn
        >
        <v-btn
          :disabled="loading"
          class="submenu-finacial"
          style="height: 31px"
          @click="handleDayMonthYear('month')"
          :class="[dayMonthYear == 'month' && 'v-dark']"
          >Mês</v-btn
        >
        <v-btn
          :disabled="loading"
          class="submenu-finacial"
          style="height: 31px"
          @click="handleDayMonthYear('year')"
          :class="[dayMonthYear == 'year' && 'v-dark']"
          >Ano</v-btn
        >
        <v-btn
          v-if="dayMonthYear == 'day'"
          :disabled="loading"
          class="submenu-finacial v-dark"
          style="height: 31px"
          @click="paginate"
          ><i class="fas fa-filter mr-1"></i> FILTRAR</v-btn
        >
      </div>
      <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 col-12 text-right">
        <select
          v-model="orderBy"
          class="form-control form-control-sm"
          @change="handleChangeFilter"
        >
          <option value="RECENTE">MAIS RECENTE</option>
          <option value="ANTIGO">MAIS ANTIGO</option>
        </select>
      </div>
    </div>
    <ErrorsMessages :errors="errors" />
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length === 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <div v-show="data.length > 0">
        <div class="row">
          <div class="col-md-12 pt-0" v-show="false">
            <input
              type="text"
              placeholder="Pesquisar..."
              v-model="search"
              class="form-control form-control-sm"
            />
          </div>
          <div class="col-md-3 col-4 pt-0">
            <v-btn
              class="p-2 btn-print"
              :disabled="selectedIds.length <= 1"
              small
              @click="handlePrints"
            >
              <i class="fas fa-print mr-1"></i>IMPRIMIR SELECIONADOS
            </v-btn>
          </div>
        </div>
        <v-data-table
          show-select
          v-model="selected"
          :search="search"
          class="v-data-table-no-border v-data-table-finance"
          :headers="headers"
          :items="data"
          item-key="index_key"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="{
            'items-per-page-options': [25],
            'items-per-page-text': 'Mostrar',
          }"
        >
          <template v-slot:[`item.date`]="{ item }">
            <div class="d-flex align-items-center">
              <div class="text-twelve" @click="handleClickRowTable(item)">
                {{
                  (item.type == "PRODUTO" || item.type == "MEDICAMENTO") &&
                  item.movement == "ENTRADA"
                    ? item.sort_date
                      ? String(item.sort_date).split("-").reverse().join("/")
                      : "--"
                    : item.date
                }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.paid_in_date`]="{ item }">
            <div class="text-twelve" @click="handleClickRowTable(item)">
              {{
                (item.type == "PRODUTO" || item.type == "MEDICAMENTO") &&
                item.movement == "ENTRADA"
                  ? "--"
                  : item.is_paid == 1
                  ? item.paid_in_date
                  : "--"
              }}
            </div>
          </template>
          <template v-slot:[`item.categories`]="{ item }">
            <div
              v-if="
                (item.type != 'PRODUTO' || item.type != 'MEDICAMENTO') &&
                item.movement != 'ENTRADA'
              "
              class="text-right"
              @click="handleClickRowTable(item)"
            >
              <v-tooltip bottom max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <p
                      :style="`background-color: ${
                        item.finance_configuration_category_color
                          ? item.finance_configuration_category_color
                          : '#999'
                      }`"
                      :class="[
                        'pl-1 pr-1 m-0 limit-text worksansr text-twelve',
                        String(
                          item.finance_configuration_category_color
                        ).toUpperCase() == '#FFFFFF'
                          ? ''
                          : 'c-white',
                      ]"
                    >
                      {{ item.finance_configuration_category_name }}
                    </p>
                  </div>
                </template>
                <span>
                  {{ item.finance_configuration_category_name }}
                </span>
              </v-tooltip>
            </div>
            <span
              v-if="
                (item.type == 'PRODUTO' || item.type == 'MEDICAMENTO') &&
                item.movement == 'ENTRADA'
              "
              >--</span
            >
          </template>
          <template v-slot:[`item.description`]="{ item }">
            <v-tooltip
              v-if="
                (item.type != 'PRODUTO' || item.type != 'MEDICAMENTO') &&
                item.movement != 'ENTRADA'
              "
              bottom
              max-width="500"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <div @click="handleClickRowTable(item)">
                    <p class="m-0 worksansr text-twelve">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
              </template>
              <div class="row m-0">
                <div class="col-md-12 pt-0 pb-0">
                  <small>Descrição</small>
                  <p class="m-0">{{ item.description }}</p>
                </div>
                <div class="col-md-12 pt-0 pb-0">
                  <small>Conta</small>
                  <p class="m-0">
                    {{ item.finance_configuration_account_name }}
                  </p>
                </div>
                <div class="col-md-6 pt-0 pb-0">
                  <small>Competência</small>
                  <p class="m-0">
                    {{ moment(item.competence).format("DD/MM/YYYY") }}
                  </p>
                </div>
                <div class="col-md-6 pt-0 pb-0 text-right">
                  <small>Vencimento</small>
                  <p class="m-0">
                    {{ moment(item.due_date).format("DD/MM/YYYY") }}
                  </p>
                </div>
                <div class="col-md-12 pt-0 pb-0 d-flex">
                  <small class="mr-2">Criado em:</small>
                  <p class="m-0">
                    {{ moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") }}
                  </p>
                </div>
                <div class="col-md-12 pt-0 pb-0 d-flex">
                  <small class="mr-2">por:</small>
                  <p class="m-0">
                    {{ item.user_name }}
                  </p>
                </div>
              </div>
            </v-tooltip>
            <div
              v-if="
                (item.type == 'PRODUTO' || item.type == 'MEDICAMENTO') &&
                item.movement == 'ENTRADA'
              "
            >
              <div v-if="item.entity" class="row">
                <div class="col-md-12 pt-0 pb-0 border-bottom">
                  <small>{{ item.type }}:</small>
                  <small
                    ><strong class="ml-2">{{
                      item.entity.medicine_product_name
                    }}</strong></small
                  >
                </div>
                <div class="col-md-6 col-sm-12 pt-0 pb-0 border-bottom">
                  <small>GRUPO:</small>
                  <small
                    ><strong class="ml-2">{{
                      item.entity.stock_group_name
                    }}</strong></small
                  >
                </div>
                <div class="col-md-6 col-sm-12 pt-0 pb-0 border-bottom">
                  <small>QUANTIDADE:</small>
                  <small
                    ><strong class="ml-2">{{
                      item.entity.amount
                    }}</strong></small
                  >
                </div>
                <div class="col-md-6 col-sm-12 pt-0 pb-0 border-bottom">
                  <small>LOTE:</small>
                  <small
                    ><strong class="ml-2">{{ item.entity.lot }}</strong></small
                  >
                </div>
                <div class="col-md-6 col-sm-12 pt-0 pb-0 border-bottom">
                  <small>VENCIMENTO:</small>
                  <small
                    ><strong class="ml-2">{{
                      item.entity.due_date
                    }}</strong></small
                  >
                </div>
                <div class="col-md-12 pt-0 pb-0 border-bottom">
                  <small>ENTRADA:</small>
                  <small
                    ><strong class="ml-2">{{
                      item.entity.entry_date
                    }}</strong></small
                  >
                  <br />
                  <small>REGISTRO:</small>
                  <small
                    ><strong class="ml-2">{{
                      String(item.sort_date).split("-").reverse().join("/")
                    }}</strong></small
                  >
                </div>
              </div>
            </div>
          </template>
          <template v-slot:[`item.value`]="{ item }">
            <div
              v-if="
                (item.type != 'PRODUTO' || item.type != 'MEDICAMENTO') &&
                item.movement != 'ENTRADA'
              "
              style="min-width: 100px !important"
              :class="[`c-${item.color}`, 'text-right']"
            >
              {{ item.color == "danger" ? "-" : "" }}
              {{ formatMoney(String(item.value).replace("-", "")) }}
            </div>
            <div
              v-if="
                (item.type == 'PRODUTO' || item.type == 'MEDICAMENTO') &&
                item.movement == 'ENTRADA'
              "
              style="min-width: 100px !important"
              class="c-success text-right"
            >
              {{ formatMoney(String(0)) }}
            </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div
              v-if="
                (item.type != 'PRODUTO' || item.type != 'MEDICAMENTO') &&
                item.movement != 'ENTRADA'
              "
              class="text-right"
            >
              <v-btn
                :class="[
                  'p-2',
                  !item.late_payment && 'btn-edit',
                  item.late_payment && 'btn-i',
                ]"
                x-small
                v-if="item.is_paid == 0"
              >
                <i class="fas fa-clock mr-1"></i>
                PAGAR
              </v-btn>
              <v-btn class="p-2 btn-save" x-small v-if="item.is_paid == 1">
                <i class="fas fa-check mr-1"></i>PAGO
              </v-btn>
            </div>
            <div
              v-if="
                (item.type == 'PRODUTO' || item.type == 'MEDICAMENTO') &&
                item.movement == 'ENTRADA'
              "
              class="text-right"
            >
              FAMÍLIA
            </div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <div class="text-right">
              <v-btn class="p-2 btn-print" x-small @click="handlePrint(item)">
                <i class="fas fa-print mr-1"></i>IMPRIMIR
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <!-- v-if="
            (type != 'PRODUTO' || type != 'MEDICAMENTO') &&
            movement != 'ENTRADA'
          " -->
        <div
          class="
            mt-2
            mb-5
            pt-2
            border-top
            d-flex
            align-items-end
            justify-content-end
          "
        >
          <h4 class="m-0 mr-2">TOTAL:</h4>
          <h4 class="c-success m-0">
            {{ formatMoney(String(totalValue)) }}
          </h4>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../templates/Components/ErrorsMessages";

import routes from "../../routes";

import api from "../../services/api";

import { isNumeric, formatMoney } from "../../lib/format";

import moment from "moment";

export default {
  name: "MenuAccount",

  components: {
    ErrorsMessages,
  },

  props: {
    resident: { type: Object },
  },

  data() {
    return {
      selected: [],
      selectedIds: [],
      search: "",
      options: {
        page: 1,
      },

      orderBy: "RECENTE",
      month: moment().format("YYYY-MM"),
      month_tmp: moment().format("YYYY-MM"),
      dayMonthYear: "month",

      resident_id: "",

      types: ["SERVICO", "PRODUTO", "MEDICAMENTO", "HOSPEDAGEM"],
      type: "SERVICO",
      origin: null,
      movement: null,
      movements: [
        { id: null, label: "TODOS" },
        { id: "ENTRADA", label: "ENTRADA" },
        { id: "VENDA", label: "VENDA" },
      ],
      status: [],
      due_date: "",

      headers: [
        { text: "VENCIMENTO", value: "date", sortable: false },
        { text: "PAGO", value: "paid_in_date", sortable: false },
        { text: "CATEGORIA", value: "categories", sortable: false },
        { text: "Descrição", value: "description", sortable: false },
        { text: "VALOR", value: "value", sortable: false, align: "end" },
        { text: "STATUS", value: "status", sortable: false, align: "end" },
        { text: "", value: "action", sortable: false, align: "end" },
      ],

      data: [],
      total: 0,
      totalValue: 0,

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  watch: {
    selected() {
      this.selectedIds = this.selected.map(({ _id }) => _id);
    },

    options: {
      handler() {
        this.paginate();
      },
    },
  },

  methods: {
    moment,
    isNumeric,
    formatMoney,

    handlePrevMonth() {
      let { dayMonthYear } = this;

      if (dayMonthYear == "day") {
        this.month = moment(this.month)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      } else if (dayMonthYear == "month") {
        this.month = moment(this.month).subtract(1, "month").format("YYYY-MM");
      } else {
        this.month = moment(this.month).subtract(1, "year").format("YYYY");
      }
      this.paginate();
    },

    handleNextMonth() {
      let { dayMonthYear } = this;

      if (dayMonthYear == "day") {
        this.month = moment(this.month).add(1, "days").format("YYYY-MM-DD");
      } else if (dayMonthYear == "month") {
        this.month = moment(this.month).add(1, "month").format("YYYY-MM");
      } else {
        this.month = moment(this.month).add(1, "year").format("YYYY");
      }

      this.paginate();
    },

    handleDayMonthYear(dayMonthYear) {
      if (dayMonthYear == this.dayMonthYear) {
        return;
      }

      let { month, month_tmp } = this;

      this.month = moment().format("YYYY-MM-DD");

      if (dayMonthYear == "month") {
        this.month = moment(month_tmp).format("YYYY-MM");
        this.month_tmp = moment(month_tmp).format("YYYY-MM");
      }

      if (dayMonthYear == "year") {
        this.month = moment(month).format("YYYY");
        this.month_tmp = moment(month_tmp).format("YYYY-MM-DD");
      }

      this.dayMonthYear = dayMonthYear;
      this.paginate();
    },

    handleInputMonthTypeYear(year) {
      if (String(year).length == 4) {
        if (isNumeric(year)) {
          this.paginate();
        }
      }
    },

    handleClickRowTable(item) {
      item;
    },

    handlePrint(item) {
      let { resident_id, origin } = this;

      let params = {
        resident_id,
        type: item.type,
        origin: origin ? origin : false,
        movement: item.action
          ? "ENTRADA"
          : item.movement
          ? item.movement
          : false,
        id: item._id,
      };

      let route = this.$router.resolve({
        name: "resident-account-print",
        params,
      });

      window.open(route.href, "_blank");
    },

    handlePrints() {
      let { resident_id, types, origin, movement, selectedIds } = this;

      let ids = [];
      for (let id of selectedIds) {
        if (!ids.includes(id)) {
          ids.push(id);
        }
      }

      let params = {
        resident_id,
        types: types.map((type) => type).join(","),
        origin: origin ? origin : false,
        movement: movement ? movement : false,
        ids: ids.map((id) => id).join(","),
      };

      let route = this.$router.resolve({
        name: "resident-account-prints",
        params,
      });

      window.open(route.href, "_blank");
    },

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;
    },

    handleChangeFilter() {
      this.paginate();
    },

    handleChangeFilterType() {
      this.selected = [];
      this.selectedIds = [];
      this.origin = "FAMILIA";
      this.movement = "ENTRADA";
      this.status = [];
      this.due_date = "";

      let { types } = this;

      if (types.includes("SERVICO") || types.includes("HOSPEDAGEM")) {
        this.origin = null;
        this.movement = null;
      } else {
        this.origin = "FAMILIA";
        this.movement = "ENTRADA";
      }

      this.paginate();
    },

    handleChangeFilterOrigin() {
      let { origin } = this;

      if (origin == "FAMILIA") {
        this.movement = "ENTRADA";
        this.movements = [{ id: "ENTRADA", label: "ENTRADA" }];
      } else if (origin == "EMPRESA") {
        this.movement = "VENDA";
        this.movements = [{ id: "VENDA", label: "VENDA" }];
      } else {
        this.movement = null;
        this.movements = [
          { id: null, label: "TODOS" },
          { id: "ENTRADA", label: "ENTRADA" },
          { id: "VENDA", label: "VENDA" },
        ];
      }

      this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let {
          resident_id,
          type,
          types,
          origin,
          movement,
          status,
          due_date,
          month,
          dayMonthYear,
          orderBy,
        } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          resident_id,
          type,
          types,
          origin,
          movement,
          status,
          due_date,
          page,
          itemsPerPage,
          month,
          dayMonthYear,
          orderBy,
        };

        let response = await api.get("/rest-home/resident/account", {
          params,
        });

        let { error, errors, data, totalValue, total } = response.data;

        if (error) {
          this.errors = errors;
          this.data = [];
        } else {
          this.data = data;
          this.totalValue = totalValue;
          this.total = total;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
